export const environment = {
  production: false,
  apiUrl: "https://nprd-api.brightsidecounseling.org",
  /** Auto-fill email when non-empty and valid; otherwise random per run. UI override wins. */
  devAutofillEmail: null as string | null,
};
